(function() {
  var YELLOW = getComputedStyle(document.documentElement).getPropertyValue('--easify-dropdown-selected-bg').trim() || '#f5f0a0';
  var DARK = '#1a1a1a';

  function applyYellow() {
    var containers = document.querySelectorAll(
      '[id*="easify"], [id*="epo"], [class*="easify"], [class*="epo-wrapper"], [data-easify], .easify-app, #easify-options'
    );
    if (!containers.length) {
      containers = document.querySelectorAll('.product-form, .product__info-wrapper');
    }
    containers.forEach(function(container) {
      var items = container.querySelectorAll(
        '[class*="active"], [class*="selected"], [class*="checked"], [aria-pressed="true"], [aria-selected="true"], input[type=radio]:checked + label, input[type=checkbox]:checked + label'
      );
      items.forEach(function(el) {
        if (el.tagName === 'BUTTON' && (el.closest('.product-form__submit') || el.closest('.shopify-payment-button'))) return;
        el.style.setProperty('background-color', YELLOW, 'important');
        el.style.setProperty('border-color', DARK, 'important');
        el.style.setProperty('color', DARK, 'important');
      });
    });
  }

  function applyDropdownHighlight() {
    var dropdownInputs = document.querySelectorAll('.tpo_option-input.tpo_option-dropdown');
    dropdownInputs.forEach(function(inp) {
      var wrapper = inp.closest('.tpo_option-input-wrapper-dropdown');
      var inner = wrapper ? wrapper.querySelector('.tpo_option-input-inner') : null;
      if (!inner) return;
      if (inp.value && inp.value.trim() !== '') {
        inner.style.setProperty('background-color', YELLOW, 'important');
        inner.style.setProperty('border-color', DARK, 'important');
      } else {
        inner.style.removeProperty('background-color');
        inner.style.removeProperty('border-color');
      }
    });
  }

  function applyAll() {
    applyYellow();
    applyDropdownHighlight();
  }

  function setupBuyButtonFeedback() {
    var form = document.querySelector('.product-form');
    if (!form || form.dataset.momentFeedback) return;
    var submitBtn = form.querySelector('[name="add"]');
    if (!submitBtn) return;
    form.dataset.momentFeedback = '1';

    var feedback = document.createElement('div');
    feedback.id = 'moment-cart-feedback';
    feedback.style.cssText = 'display:none;padding:12px 16px;border-radius:6px;margin-bottom:12px;font-size:1.4rem;font-weight:600;text-align:center;';
    var btnWrapper = submitBtn.closest('.product-form__buttons') || submitBtn.parentElement;
    btnWrapper.insertBefore(feedback, btnWrapper.firstChild);

    var errorWrapper = form.querySelector('.product-form__error-message-wrapper');

    function showError(text) {
      feedback.textContent = '⚠ ' + text;
      feedback.style.display = 'block';
      feedback.style.backgroundColor = '#fee2e2';
      feedback.style.color = '#991b1b';
      feedback.style.border = '1px solid #fca5a5';
      feedback.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function showSuccess() {
      feedback.textContent = '✓ ¡Añadido al carrito!';
      feedback.style.display = 'block';
      feedback.style.backgroundColor = '#dcfce7';
      feedback.style.color = '#166534';
      feedback.style.border = '1px solid #86efac';
      setTimeout(function() { feedback.style.display = 'none'; }, 3000);
    }

    if (errorWrapper) {
      var attrObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          if (m.attributeName === 'hidden') {
            if (!errorWrapper.hasAttribute('hidden')) {
              var msg = errorWrapper.querySelector('.product-form__error-message');
              showError(msg ? msg.textContent.trim() : 'Este artículo no está disponible');
            } else {
              feedback.style.display = 'none';
            }
          }
        });
      });
      attrObserver.observe(errorWrapper, { attributes: true, attributeFilter: ['hidden'] });
    }

    var pendingSuccess = null;
    submitBtn.addEventListener('click', function() {
      feedback.style.display = 'none';
      if (pendingSuccess) clearTimeout(pendingSuccess);
      pendingSuccess = setTimeout(function() {
        if (feedback.style.display === 'none') {
          showSuccess();
        }
      }, 2500);
    });
  }

  function init() {
    applyAll();
    setupBuyButtonFeedback();

    var classObserver = new MutationObserver(function(mutations) {
      var relevant = mutations.some(function(m) {
        return m.type === 'attributes' && m.attributeName === 'class';
      });
      if (relevant) applyAll();
    });
    var target = document.querySelector('.product-form, .product__info-wrapper, body');
    if (target) {
      classObserver.observe(target, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    document.body.addEventListener('click', function(e) {
      setTimeout(applyAll, 100);
      setTimeout(applyAll, 400);
    });

    var lastValues = {};
    var pollCount = 0;
    var poller = setInterval(function() {
      var inputs = document.querySelectorAll('.tpo_option-input.tpo_option-dropdown');
      var changed = false;
      inputs.forEach(function(inp, i) {
        if (lastValues[i] !== inp.value) {
          lastValues[i] = inp.value;
          changed = true;
        }
      });
      if (changed) applyDropdownHighlight();
      pollCount++;
      if (pollCount > 60) clearInterval(poller);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function() {
    applyAll();
    setTimeout(function() { applyAll(); setupBuyButtonFeedback(); }, 500);
    setTimeout(function() { applyAll(); setupBuyButtonFeedback(); }, 1500);
  });
})();
